module.exports = __webpack_public_path__ + "img/heart_structureFunction_bj.0899e726.png";